import { type ReportHandler } from 'web-vitals';

/**
 * Web Vitals reporting function
 * Used to measure and report Core Web Vitals like CLS, FID, etc.
 *
 * @param {ReportHandler} [onPerfEntry] - Optional callback function to handle performance metrics
 * @see https://bit.ly/CRA-vitals for more information on Web Vitals
 */
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Cumulative Layout Shift
      getCLS(onPerfEntry);
      // First Input Delay
      getFID(onPerfEntry);
      // First Contentful Paint
      getFCP(onPerfEntry);
      // Largest Contentful Paint
      getLCP(onPerfEntry);
      // Time to First Byte
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
